import React from 'react'
import links from 'links'
import { useWeather } from 'models/weather'

import { Text } from 'components/dataDisplay'
import { ActionButton } from 'components/inputs'


type WeatherWidgetProps = {
  className?: string
}

const WeatherWidget: React.FC<WeatherWidgetProps> = ({ className }) => {
  const { temp, condition, icon, schoolAlert } = useWeather({})

  const { schoolClass } = schoolAlert || {}

  return (
    <div className={className}>
      {
        Boolean(typeof temp === 'number' && condition && icon) && (
          <>
            <div className="flex items-end">
              <Text
                message={`${temp}°`}
                size="h40"
                color="rocky"
              />
              <img
                className="ml-12px inline"
                srcSet={icon + ' 2x'}
                alt="weather condition"
              />
            </div>
            <Text
              className="mt-8px"
              message={condition}
              size="s13-r"
            />
            {
              schoolClass && (
                <Text
                  className="mt-4px opacity-72"
                  message={`Неблагоприятно для 1-${String(schoolClass)} классов`}
                  size="s13-r"
                  color="lebowski"
                />
              )
            }
            <ActionButton
              className="mt-8px"
              title="Подробнее"
              to={links.weather}
              color="rocky"
            />
          </>
        )
      }
    </div>
  )
}

export default WeatherWidget